import API from '../../../common/http/api.fetch';
import { PNP_ADD_APPROVERS_CONTACTS, PNP_ADD_REVIEWERS_CONTACTS, PNP_APPROVERS_CONTACTS, PNP_DOCUMENT_APPLICATION_TYPES, PNP_REMOVE_APPROVERS_CONTACTS, PNP_REMOVE_REVIEWERS_CONTACTS, PNP_REVIEWERS_APPROVERS_TYPES, PNP_REVIEWERS_CONTACTS } from '../pnp.actions.types';
import { PNP_DOCUMENT_TYPES, PNP_DOCUMENT_CATEGORIES, PNP_DOCUMENT_RISK_LEVELS, PNP_DOCUMENT_STATUSES ,PNP_ACCREDITATION_SCHEMES , PNP_ACCREDITATION_SECTION } from './pnp-docs.actions.types';
import { responseMessage} from '../../../common/utils/util.notifier';

export const getDocumentTypes = (documentCode) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-types`,
            method: 'GET',
            params: {
                documentCode: documentCode
            }
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_TYPES,
                id: 'pnpDocument',
                items: response.data.map(item => {
                    return {
                        value: item.doc_type_id,
                        label: item.doc_type_name,
                        item: {
                            documentTypeId: item.doc_type_id,
                            documentTypeName: item.doc_type_name,
                            documentTypeCode: item.doc_type_code
                        }
                    }
                })
            });
        });
    }
}

export const getDocumentCategories = (location) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-categories`,
            method: 'GET',
            params: {
                offset: 0,
                limit: 100,
                location: location
            }
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_CATEGORIES,
                id: 'pnpDocument',
                items: response.data.items.map(({ name, location_name, dca_id , prefix}) => ({
                    value: dca_id,
                    label: location_name === 'dosel' ? name : `${name} - ( ${location_name} )`,
                    prefixName : prefix
                }))
            });
        });
    }
}

export const getDocumentRiskLevels = () => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-risk-levels`,
            method: 'GET',
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_RISK_LEVELS,
                id: 'pnpDocument',
                items: response.data.map(item => {
                    return {
                        value: item.drl_id,
                        label: item.risk_level_name,
                        unit: item.unit,
                        drl_id: item.drl_id,
                        review_freq: item.review_freq
                    }
                })
            });
        });
    }
}

export const getDocumentApplicationTypes = (parCode) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-application-types`,
            method: 'GET',
            params: {
                parCode: parCode,
                limit: 1000,
                offset: 0
            }
        }).then((response) => {
            dispatch({
                type: PNP_DOCUMENT_APPLICATION_TYPES,
                id: 'pnpDocument',
                items: response.data.map(item => {
                    return {
                        value: item.type_id,
                        label: item.name,
                        code: item.code
                    }
                })
            });
        });
    }
}

export const fetchReviewerApproverTypes = (documentCategory, documentRiskLevel) => {
    return dispatch => {
        return API.fetch({
            url: `/pnp/doc-review-approve-types`,
            method: 'GET',
            params: { documentCategory, documentRiskLevel }
        }).then(({data}) => {
            const reviewers = data.filter((type)=>type.task_type==='Document Review Task').map((type)=>type.subject_id).join(',')
            const approvers = data.filter((type)=>type.task_type==='Document Approval Task').map((type)=>type.subject_id).join(',')
            dispatch({
                type: PNP_REVIEWERS_APPROVERS_TYPES,
                id: 'pnpDocument',
                reviewApproverTypes: {
                    reviewers: reviewers,
                    approvers: approvers
                },
            })
        })
    }
}

export const fetchReviewersContacts = (loc_uuid) => {
    return dispatch => {
        return API.fetch({
            url: `/pnp/doc/managers`,
            method: 'GET',
            params: { loc_uuid }
        }).then(({data}) => {
            dispatch({
                type: PNP_REVIEWERS_CONTACTS,
                id: 'pnpDocument',
                autocompleteReviewers: data.reduce((result, user) => {
                    if(!result.find(item => item.sub_uuid === user.sub_uuid)) {
                        result.push({ ...user,
                            employee_uuid: user.sub_uuid,
                            subject_type_name: user.sty_name,
                        })
                    }
                    return result;
                },[]),
            })
        })
    }
}

export const getDocumentStatuse = () => {
    return dispatch => {
        return API.fetch({
            url: `/pnp/doc/statuses`,
            method: 'GET'
        }).then(({data}) => {
            dispatch({
                type: PNP_DOCUMENT_STATUSES,
                id: 'pnpDocument',
                items: data.map(item => {
                    return {
                        value: item.sta_id,
                        label: item.name,
                        code: item.code
                    }
                })
            })
        })
    }
}

export const addReviewerContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_ADD_REVIEWERS_CONTACTS,
            id: 'pnpDocument',
            path: 'pnpDocument.selectedReviewers',
            item
        });
    };
};

export const removeReviewerContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_REMOVE_REVIEWERS_CONTACTS,
            id: 'pnpDocument',
            path: 'pnpDocument.selectedReviewers',
            item
        });
    };
};

export const fetchApproversContacts = (loc_uuid) => {
    return dispatch => {
        return API.fetch({
            url: `/pnp/doc/managers`,
            method: 'GET',
            params: { loc_uuid }
        }).then(({data}) => {
            dispatch({
                type: PNP_APPROVERS_CONTACTS,
                id: 'pnpDocument',
                autocompleteApprovers: data.reduce((result, user) => {
                    if(!result.find(item => item.sub_uuid === user.sub_uuid)) {
                        result.push({ ...user,
                            employee_uuid: user.sub_uuid,
                            subject_type_name: user.sty_name,
                        })
                    }
                    return result;
                },[]),
            })
        })
    }
}

export const addApporverContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_ADD_APPROVERS_CONTACTS,
            id: 'pnpDocument',
            path: 'pnpDocument.selectedApprovers',
            item
        });
    };
};

export const removeApproverContacts= (item) => {
    return dispatch => {
        return dispatch({
            type: PNP_REMOVE_APPROVERS_CONTACTS,
            id: 'pnpDocument',
            path: 'pnpDocument.selectedApprovers',
            item
        });
    };
};

export const getAccreditationSchemes = () => {
    return (dispatch) => {
        return API.fetch({
            url:'/rco/list-regulatory-schemes',
            method: 'GET',
            params: {
                for_assessment_only: 1,
                limit: -1,
                offset: 0,
            }
        }).then((response) => {
            const schemes = response.data.map(item => ({
                value: item.code,
                label: item.name,
            }));

            dispatch({
                type: PNP_ACCREDITATION_SCHEMES,
                id: 'pnpDocument',
                items: schemes,
            });

            return schemes;
        });
    };
};

export const getAccreditationSection = (scheme_code, slo_uuid = null, fiscal_year = null) => {
    return dispatch => {
        if (!scheme_code) {
            console.warn("scheme_code is required but not provided.");
            return;
        }
        return API.fetch({
            url:    '/rco/framework-requirements-tree',
            method: 'GET',
            params: (slo_uuid && fiscal_year) ? { scheme_code, slo_uuid, fiscal_year } : { scheme_code },
        }).then(response => {
            dispatch({
                type:  PNP_ACCREDITATION_SECTION,
                id: 'pnpDocument',
                items:   response.data
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const getFrameworkRequirementDetails = (node) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/framework-requirement-details',
            method: 'GET',
            params: {id: node.id}
        }).then(response => {
            dispatch({
                type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsRequirementDetails,
                data:   {
                    ...response.data[0],
                    id:                 node.id,
                    standardParentId:   node.standardParentId,
                    level:              node.level,
                    nodeName:           node.name,
                    prefix:             node.number,
                    siblings:           node.children.map(item => parseInt(item.numberRaw.split('.').pop())),
                    schemeCode:         node.schemeCode,
                }
            })
        }, error => {
            responseMessage(error);
        });
    };
}
